"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.alertTypes = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AlertLink = _interopRequireDefault(require("./AlertLink"));
var _AlertIcon = _interopRequireDefault(require("./AlertIcon"));
var _AlertHeader = _interopRequireDefault(require("./AlertHeader"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AlertBoxModule = _interopRequireDefault(require("./AlertBox.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const alertTypes = exports.alertTypes = {
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning",
  INFO: "info"
};
const AlertBox = _ref => {
  let {
    message,
    type = alertTypes.ERROR,
    link,
    linkTo,
    children,
    icon,
    header
  } = _ref;
  if (children) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_AlertBoxModule.default.messageBox, _AlertBoxModule.default[`alert-${type}`])
    }, children);
  }
  if (message) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_AlertBoxModule.default.messageBox, _AlertBoxModule.default[`alert-${type}`])
    }, /*#__PURE__*/_react.default.createElement(_AlertIcon.default, {
      icon: icon
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: _AlertBoxModule.default.content
    }, /*#__PURE__*/_react.default.createElement(_AlertHeader.default, {
      header: header
    }), /*#__PURE__*/_react.default.createElement("div", null, message), /*#__PURE__*/_react.default.createElement(_AlertLink.default, {
      link: link,
      linkTo: linkTo
    })));
  }
  return null;
};
AlertBox.propTypes = {
  type: _propTypes.default.oneOf(["error", "success", "warning", "info"]),
  message: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string])
};
AlertBox.defaultProps = {
  type: "error",
  message: undefined
};
var _default = exports.default = AlertBox;